import { HttpServiceResponse } from '../../shared'
import { ViewFilesParams } from '../models'
import AbstractAccountProvider from './linkedFiles-abstract.provider'

export class ViewFilesProvider extends AbstractAccountProvider {
  urlPath = 'linkedfiles_view_file_api'

  public view<T>(params: ViewFilesParams): Promise<HttpServiceResponse<T>> {
    return this.http.post(this.url, params, {
      responseType: 'blob',
    })
  }
}
